const main = {
    main: {
        missionSupport1: 'We offer all-in-one management and support for your satellite missions.',
        missionSupport2: 'Connect with IOPS SPACE from anywhere and expand your space business.',
        getStarted: 'Get Started',
        overview: {
            sectionTitle: 'Overview',
            sectionSubtitle: 'All-in-one solution for Spacecraft',
            card1Title: 'Orbital Scheduling',
            card1Desc: 'Satellite orbit prediction and ground station contact scheduling',
            card2Title: 'Mission Control',
            card2Desc: 'Real-time tracking of satellites along orbital paths and AI-based mission control.',
            card3Title: 'Contribute',
            card3Desc: 'Provide processing and analysis solution based on requests'
        },
        slider: {
            slide1: {
                title: 'Verify our reliable technology',
                desc: 'Our software has continuously improved throughout our business,\nobtaining international standard information protection and security certification.',
                stat1: {
                    line1: 'National satellite operation projects',
                    line2: '(Over 42.3 billion won)'
                },
                stat2: {
                    line1: 'Satellite operation S/W',
                    line2: 'development results'
                },
                stat3: {
                    line1: 'Self-developed satellite',
                    line2: 'operation/control S/W'
                }
            },
            slide2: {
                title: 'Expand your satellite communication coverage',
                desc: 'We provide our ground station network, cloud modems, and a global partner ecosystem.'
            },
            slide3: {
                title: 'Experience our expertise',
                desc: 'Our team of experts consists of 150 members who specialize in AI development, satellite communication system development, analysis, planning and customer service.'
            }
        },
        benefits: {
            sectionTitle: 'Benefits',
            sectionSubtitle: 'Easy and Reasonable solution',
            card1: {
                title: 'We Need Your Email Only',
                desc: 'Collect satellite data without unnecessary information gathering.'
            },
            card2: {
                title: 'Pay Only for Antenna Usage Time',
                desc: 'You can reduce costs and time for your satellite business.'
            },
            card3: {
                title: 'Real-Time & Automated System',
                desc: 'We operate a 24-hour satellite monitoring and automated control system.'
            }
        },
        features: {
            sectionTitle: 'Features',
            sectionSubtitle: 'How to use',
            steps: {
                getStarted: {
                    title: 'Get started',
                    desc: "Let's get into the IOPS SPACE!"
                },
                manageSpacecraft: {
                    title: 'Manage Spacecraft',
                    desc: 'Register satellite information'
                },
                contactProfile: {
                    title: 'Contact Profile',
                    desc: 'Search and connect with Groundstation'
                },
                scheduleContact: {
                    title: 'Schedule a Contact',
                    desc: 'Schedule a contact with a single click.'
                }
            }
        },
        contact: {
            sectionTitle: 'Contact',
            sectionSubtitle: 'Would you like to get on board?',
            form: {
                enquiryType: 'Enquiry Type',
                name: 'Name',
                namePlaceholder: 'Input your name',
                company: 'Company / Department',
                companyPlaceholder: 'Input your company information',
                email: 'Contacts',
                emailPlaceholder: 'Input your email address',
                country: 'Country',
                inquiry: 'Inquiry Contents',
                agree:
                    'I have read and agree to the privacy policy and terms of use.\nRead the Privacy Policy and terms of use below.',
                submit: 'Submit',
                enquiryOptions: {
                    use: 'Use a ground station',
                    share: 'Share a ground station',
                    estimate: 'Estimate Inquiry',
                    press: 'Make a press inquiry',
                    other: 'Other'
                }
            }
        }



    }

}

export default main;